import { render, staticRenderFns } from "./client-unit-multicompart.vue?vue&type=template&id=5ee7fa80&scoped=true&lang=pug&"
import script from "./client-unit-multicompart.vue?vue&type=script&lang=ts&"
export * from "./client-unit-multicompart.vue?vue&type=script&lang=ts&"
import style0 from "./client-unit-multicompart.vue?vue&type=style&index=0&id=5ee7fa80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee7fa80",
  null
  
)

export default component.exports